import Carousel from 'react-bootstrap/Carousel';
import {Change} from '../compare/Change'
import LockCompetitor from '../Button/LockCompetitor';
import comingSoonIMG from '../../images/image_coming_soon-min.png';
import {currencyConverter} from '../../utility/methods';
import {getVehicleDetails, handleCarouselSelect, renderCarouselItems} from './photos.utils';
import {checkLockStatus} from '../compare/compare.method';
import {useTranslation} from "react-i18next";
import React, {useEffect, useRef, useState} from "react";
import {useDispatch} from "react-redux";
import {Color} from "../compare/Color";
import {swapCompareImages} from "../../slices/vehicleSlice";

const SecondaryVehicleCarousel = ({
                                      vehicle, vehicleCode,getCompareImages,isAngleChanged,
                                      removeVehicle, isLocked, trackGalleryScrollRight,
                                      trackGalleryScrollLeft, props, vehicleData, setVehicleData,
                                      openModal, handleModalClose, secondaryYear, vehiclesMakes, vehicleModel,
                                      trimModel, setTrimModel, setVehicleModel, setVehicleMake, vehiclesTrim, vehicleIndex,
                                      vehicleTypeName, driveType, setDriveType, handleToggle, activeLocale,
                                      setOpenModal,changeHandler, profile, viewAngle,secondaryCarouselIndex, isPrimaryImageCarousel,
                                      isMobile, isMobileHeight,swapTriggered, headerLoadType
                                  }) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const [isLoadingState, setIsLoadingState] = useState(false);

    const timerRef = useRef(null);

    const vehicleCTA = "https://www.jdpower.com/cars-for-sale/make-"+ vehicle?.make.toLowerCase() + "/model-" + vehicle?.model.toLowerCase().replace(/ /g, "-")
    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (swapTriggered) {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            setIsLoadingState(true);
            timerRef.current = setTimeout(() => {
                setIsLoadingState(false);
                dispatch(swapCompareImages({ swapTriggered: false }));
                timerRef.current = null;
            }, 1000);
        }
    }, [swapTriggered]);

    return (

        <div className={"secondary-vehicle-container"}>
            <div className={'primary-vehicle-container'}>
                <div className={`${vehicle ? 'vehicle-details' : 'no-vehicle-img'}`}>
                    <div className={'vehicle-description'}>
                        {
                            getVehicleDetails(vehicle)
                        }
                        {vehicle && <div className={"msrp-price"}>
                            <span>{t('overview.startingFrom')} </span>
                            <span>{currencyConverter(vehicle?.pricing.msrp, activeLocale)}</span>
                        </div>}
                    </div>

                    <div className={"change-modal"}>
                        {headerLoadType != null && vehicle && (
                            <div className={"vehicle-CTA secondary-CTA"} style={{marginRight: '10px'}}>
                                <a target="_blank" href={vehicleCTA}>See Cars For Sale</a>
                            </div>
                        )}

                        {getCompareImages.length > 1 && <Color
                            primaryColor={getCompareImages[1]?.colors?.exteriors}
                            translate={t}
                            id={1}
                            mediaColor={getCompareImages[1]?.currentColor}
                            interiorColor={getCompareImages[1]?.colors?.interiors}
                        />}

                        <button
                            id={1}
                            className={checkLockStatus(vehicle, isLocked,1) ? `btn-default ${headerLoadType ? "jdpa-button-disabled" : "btn-change-disabled"}` : "btn-default btn-change-compare"}
                            value={vehicle}
                            onClick={(event) => changeHandler(1, vehicle)}
                            disabled={Object.keys(isLocked).length > 0 && checkLockStatus(vehicle, isLocked,1)}
                            title={checkLockStatus(vehicle, isLocked,1) ? t("overview.changeSelectModal.vehicleLocked") : null}
                        >
                            { getCompareImages.length > 1 ? t('overview.changeSelectModal.change') : t('overview.controls.selectVehicle') }
                        </button>

                        <LockCompetitor isLocked={isLocked}
                                        vehicle={vehicle}
                                        toggleLock={() => handleToggle(1, vehicle)}/>
                        <Change
                            vehicleData={vehicleData}
                            setVehicleData={setVehicleData}
                            openModal={openModal}
                            handleModalClose={handleModalClose}
                            years={secondaryYear}
                            vehicleMake={vehiclesMakes}
                            vehicleModels={vehicleModel}
                            trimModel={trimModel}
                            setTrimModel={setTrimModel}
                            setVehicleModel={setVehicleModel}
                            setVehicleMake={setVehicleMake}
                            vehiclesTrim={vehiclesTrim}
                            vehicleIndex={vehicleIndex}
                            vehicleTypeName={vehicleTypeName}
                            driveType={driveType}
                            setDriveType={setDriveType}
                            lockedVehicle={isLocked}
                            setOpenModal={setOpenModal}
                        />
                    </div>
                </div>
                <div className={`${vehicle ? 'primaryImage' : 'no-competitor-vehicle'}`}>
                    {vehicle && getCompareImages.length > 1 ? (
                        <Carousel
                            indicators={false}
                            controls={false}
                            touch={false}
                            interval={null}
                            variant={"dark"}
                            onSelect={(eventKey) =>
                                handleCarouselSelect(eventKey, vehicle, vehicleCode, props,
                                    trackGalleryScrollRight, trackGalleryScrollLeft, dispatch)}

                            activeIndex={isAngleChanged ? vehicleCode : secondaryCarouselIndex}
                        >
                            {renderCarouselItems(vehicle, isPrimaryImageCarousel, profile, viewAngle, getCompareImages,
                                removeVehicle, isLocked, comingSoonIMG, isLoadingState, isMobile, isMobileHeight, swapTriggered, t)}
                        </Carousel>
                        )
                        :
                        <div className={'competitor-image'}>
                            <div className="no-vehicle">
                                {t('overview.noVehicleSelected')}
                            </div>
                        </div>}
                </div>
            </div>
        </div>
    )
}

export default SecondaryVehicleCarousel;
